module.exports = __webpack_public_path__ + "static/img/logoT.306941e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoT.png
// module id = CPkf
// module chunks = 1